(() => {
    /** Navi placement **/
    const announcementBar = document.querySelector('#shopify-section-announcement');
    const header = document.querySelector('#section-header');
    const navDrawer = document.querySelector('#NavDrawer');
    const navDrawerButton = document.querySelector('.js-drawer-open-nav');
    const openCartDrawerButton = document.querySelector('.js-drawer-open-cart');

    const headerHeightHandler = () => {
        setTimeout(() => {
            if (window.scrollY >= announcementBar.scrollHeight) {
                const headerheight = +header.scrollHeight;
                navDrawer.style.top = (headerheight - 1) + 'px';
                navDrawer.style.height = 'calc(100dvh - ' + (headerheight - 1) + 'px';

            } else {
                const headerheight = announcementBar.scrollHeight + header.scrollHeight - window.scrollY;
                navDrawer.style.top = (headerheight - 1) + 'px';
                navDrawer.style.height = 'calc(100dvh - ' + (headerheight - 1) + 'px';

            }
        }, 200);
    }

    window.addEventListener('scroll', () => {
        // console.log("scroll")
        headerHeightHandler();
    });

    const closeNavDrawer = () => {
        navDrawer.classList.remove('drawer--is-open');
        document.body.parentElement.classList.remove('js-drawer-open', 'lock-scroll')
        // console.log("CLOSE")
    }

    const openNavDrawer = () => {
        navDrawer.classList.add('drawer--is-open');
        document.body.parentElement.classList.add('js-drawer-open', 'lock-scroll')
        // console.log("OPEN")
    }


    // open/close drawer
    navDrawerButton.addEventListener('click', (e) => {
        e.stopPropagation();
        e.preventDefault();

        headerHeightHandler();

        if (!navDrawer.classList.contains('drawer--is-open')) {
            openNavDrawer();
        } else {
            closeNavDrawer();
        }
    });

    openCartDrawerButton.addEventListener('click', (e) => {
        // e.stopPropagation();
        // e.preventDefault();

        // console.log("openCartDrawerButton")
        if (navDrawer.classList.contains('drawer--is-open')) {
            closeNavDrawer();
        }
    });

    window.addEventListener('resize', () => {
        headerHeightHandler();

        if (window.innerWidth >= 1140) {
            closeNavDrawer();
        }
    });

    // initial call
    window.dispatchEvent(new Event('resize'));

    /** Submenu handling **/
    const navItems = document.querySelectorAll('.navigation__item--submenu');

    navItems.forEach((navItem) => {
        const navArrow = navItem.querySelector('.navigation__item__arrow');
        navArrow.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();

            if (!e.target.classList.contains('navigation__item__title') && !e.target.classList.contains('navigation__subItem__title') && !e.target.classList.contains('navigation__subItem__subtitle') && !e.target.classList.contains('navigation__item__notificationBadge')) {
                if (navItem.classList.contains('navigation__item--active')) {
                    const submenu = navItem.querySelector('.navigation__item__submenu');

                    navItem.classList.remove('navigation__item--active');
                    submenu.style.height = 0;
                } else {
                    const submenu = navItem.querySelector('.navigation__item__submenu');

                    navItem.classList.add('navigation__item--active');
                    submenu.style.height = submenu.scrollHeight + 'px';
                }
            }
        });
    });

    // open first item
    setTimeout(() => {
        document.querySelector('.navigation__item__arrow').click()
    }, 1000)

    /** Language Selector **/
    const languageSelectorDropdown = navDrawer.querySelector('.LanguageSelector__dropdown');
    const languageSelectorButton = navDrawer.querySelector('.LanguageSelector__button');
    const languageSelectorItems = languageSelectorDropdown.querySelectorAll('span');
    const languageSelectorForm = navDrawer.querySelector('.LanguageSelector__Form');
    const languageSelectorFormInput = navDrawer.querySelector('.LanguageSelector__Form input[name="language_code"]');

    languageSelectorButton.addEventListener('click', () => {
        if (!languageSelectorDropdown.classList.contains('active')) {
            languageSelectorDropdown.classList.add('active');
        } else {
            languageSelectorDropdown.classList.remove('active');
        }
    });

    languageSelectorItems.forEach((language) => {
        language.addEventListener('click', () => {
            languageSelectorFormInput.value = language.dataset.value;
            languageSelectorForm.submit();
        });
    });

    // testing: open drawer
    //setTimeout(() => {
    //   navDrawerButton.click()
    //}, 500);
})();
